export default {
  'platform.chinese': '简体中文',
  'platform.linkJump': '链接跳转',
  'platform.internalJump': '站内跳转',
  'platform.noJump': '不需跳转',
  'platform.uploadTip': '只能上传jpg/png/webp/gif文件',
  'platform.uploadError': '只能上传jpg/png/jpeg/webp文件',
  'platform.bannerName': '轮播图名称',
  'platform.bannerImage': '轮播图',
  'platform.upload': '上传',
  'platform.uploadImage': '请上传图片',
  'platform.redirectLink': '跳转链接',
  'platform.link': '链接',
  'platform.linkJumpTip': '请选择链接',
  'platform.announcementName': '公告名称',
  'platform.announcementType': '公告类型',
  'platform.homepagePopup': '首页弹框',
  'platform.homepageMarquee': '首页跑马灯',
  'platform.language': '语言',
  'platform.triggerFrequency': '触发频率',
  'platform.triggerFrequency.onceEachTime': '每次',
  'platform.triggerFrequency.oncePerDay': '每日一次',
  'platform.triggerFrequency.oncePerWeek': '每周一次',
  'platform.triggerFrequency.onceOnly': '只弹一次',
  'platform.frontendDisplayStatus': '前端显示状态',
  'platform.status': '状态',
  'platform.remark': '备注',
  'platform.operator': '操作人',
  'platform.operationTime': '操作时间',
  'platform.banner': '轮播图',
  'platform.redirectLinkTitle': '跳转链接',
  'platform.lobbyId': '大厅ID:',
  'platform.input': '输入',
  'platform.invitationPage': '邀请页',
  'platform.myAccount': '我的账号',
  'platform.copywriting': '文案',

  'webPushNotifications.enable': '启用',
  'webPushNotifications.add': '新增',
  'webPushNotifications.save': '保存',
  'webPushNotifications.disable': '禁用',
  'webPushNotifications.createTime': '创建时间',
  'webPushNotifications.targetType': '推送对象',
  'webPushNotifications.targetTypeAll': '全体会员',
  'webPushNotifications.targetTypeSpecific': '指定会员',
  'webPushNotifications.triggerType': '触发机制',
  'webPushNotifications.triggerTypeManual': '手动',
  'webPushNotifications.triggerTypeNewUserNextDay': '新人隔天',
  'webPushNotifications.triggerTypeWithdrawSuccess': '出款成功',
  'webPushNotifications.triggerTypeSubRegister': '下级注册成功',
  'webPushNotifications.title': '推送标题',
  'webPushNotifications.content': '推送信息',
  'webPushNotifications.updateTime': '操作时间',
  'webPushNotifications.status': '状态',
  'webPushNotifications.remark': '备注',
  'webPushNotifications.updateBy': '操作人',
  'webPushNotifications.action': '操作',
  'webPushNotifications.statusOn': '已开启',
  'webPushNotifications.statusOff': '已关闭',

  'platform.webPushNotifications.targetType': '推送对象',
  'platform.webPushNotifications.targetTypeAll': '全体会员',
  'platform.webPushNotifications.targetTypeSpecific': '指定会员',
  'platform.webPushNotifications.targetMembersPlaceholder':
    '输入会员标识；多行添加或以英文逗号隔开',
  'platform.webPushNotifications.targetMembersRequired': '请输入会员标识',
  'platform.webPushNotifications.triggerType': '触发机制',
  'platform.webPushNotifications.triggerTypeManual': '手动',
  'platform.webPushNotifications.triggerTypeNewUserNextDay': '新人隔天',
  'platform.webPushNotifications.triggerTypeWithdrawSuccess': '出款成功',
  'platform.webPushNotifications.triggerTypeSubRegister': '下级注册成功',
  'platform.webPushNotifications.pushTitle': '推送标题',
  'platform.webPushNotifications.pushContent': '推送信息',
  'platform.webPushNotifications.linkUrl': '推送信息链接',
  'platform.webPushNotifications.mainButtonTitle': '主按钮标题',
  'platform.webPushNotifications.mainButtonLink': '主按钮链接',
  'platform.webPushNotifications.subButtonTitle': '副按钮标题',
  'platform.webPushNotifications.subButtonLink': '副按钮链接',
  'platform.webPushNotifications.common.input': '请输入',
  'platform.webPushNotifications.pushImage': '推送图',

  'platform.siteMessage.title': '标题',
  'platform.siteMessage.target': '对象',
  'platform.siteMessage.createTime': '创建时间',
  'platform.siteMessage.operator': '操作人',

  'platform.siteMessage.form.targetType': '推送对象',
  'platform.siteMessage.form.targetTypeAll': '全体会员',
  'platform.siteMessage.form.targetTypeSpecific': '指定会员',
  'platform.siteMessage.form.specifyMembers': '指定会员',
  'platform.siteMessage.form.membersPlaceholder': '输入会员标识；多行添加或以英文逗号隔开',
  'platform.siteMessage.form.membersRequired': '请输入会员标识',
  'platform.siteMessage.form.title': '标题',
  'platform.siteMessage.form.titlePlaceholder': '输入',
  'platform.siteMessage.form.titleRequired': '请输入标题',
  'platform.siteMessage.form.content': '内容',

  'platform.maxIpRegistrations': '同IP最大注册账号数量',
  'platform.maxDeviceRegistrations': '同设备最大注册账号数量',
  'platform.update': '更新',
  'platform.unlimited': '不限制',
  'platform.updateSuccess': '更新成功',
  'platform.updateFailed': '更新失败，请重试',
  'platform.validationError': '请输入 1 到 999999 之间的整数',
  'platform.registrationSettings': '注册设置',
  'platform.loginSettings': '登录设置',
  'platform.phoneSmsLogin': '手机号+验证码',
  'platform.maxDeviceLogins': '同设备最大登录账号数量',

  'platform.suspendedball.cardTitle': '悬浮球配置',
  'platform.suspendedball.updateBtn': '更新',
  'platform.suspendedball.updateSuccess': '更新成功',
  'platform.suspendedball.close': '关闭',
  'platform.suspendedball.open': '开启',
  'platform.suspendedball.label': '悬浮球',
  'platform.contactConfig.cardTitle': '社媒与客服',
  'platform.contactConfig.typeCustomerService': '客服',
  'platform.contactConfig.typeEmail': '邮箱',
  'platform.contactConfig.save': '保存配置',
  'platform.contactConfig.sortRange': '请输入 1-99 的排序值',
  'platform.suspendedball.status': '状态',
  'platform.suspendedball.uploadBtnText': '上传',
  'platform.suspendedball.uploadTip': '只能上传jpg/png/webp/gif文件',
  'platform.suspendedball.suggestSize': '建议尺寸为',
  'platform.suspendedball.uploadError': '图片大小或格式错误',
  'platform.suspendedball.uploadRule': '请上传悬浮球图片',
  'platform.suspendedball.jumpType': '跳转类型',
  'platform.suspendedball.externalJump': '外部跳转',
  'platform.suspendedball.activityJump': '活动跳转',
  'platform.suspendedball.jumpLink': '跳转链接',
  'platform.suspendedball.placeholderInput': '请输入',
  'platform.suspendedball.placeholderSelect': '请选择',
  'platform.suspendedball.inputRule': '请输入跳转链接',
  'platform.suspendedball.selectRule': '请选择活动',

  'platform.pixelIdTemplate': '像素ID模板',
  'platform.pixelIdTemplateName': '像素ID模板名称',
  'platform.point.Channelname': '渠道名称',
  'platform.point.Channelpromotionlink': '渠道推广链接',
  'platform.point.ChannelID': '渠道ID',
  'platform.point.Platform': '平台',
  'platform.point.PixelID': '像素ID',
  'platform.point.Notes': '备注',
  'platform.point.Operationtime': '操作时间',
  'platform.point.Operation': '操作',
  'platform.point.AssociatepixelID': '关联像素ID',
  'platform.point.Disassociate': '解除关联',
  'platform.point.unbindsure': '确定解除“渠道推广链接”和“像素ID”绑定吗',
  'platform.point.Switch': '开关',
  'platform.point.EnableTips': '启用：域名推广链接正常采集事件记录。',
  'platform.point.DisableTips': '禁用：域名推广链接停止采集事件记录。',
  'platform.point.Click': '点击',
  'platform.point.Register': '注册',
  'platform.point.Recharge': '首充',
  'platform.point.Secondcharge': '二充',
  'platform.point.Purchase': '购物',
  'platform.point.Addtocart': '加入购物车',
  'platform.point.Initiatecheckout': '发起结账',
  'platform.point.Buriedpointrecord': '埋点记录',
  'platform.point.Registrationtime': '注册时间',
  'platform.point.starttime': '请选择开始时间',
  'platform.point.endtime': '请选择结束时间',
  'platform.point.RegistrationURL': '注册网址',
  'platform.point.Parentmemberaccount': '上级会员ID',
  'platform.point.MemberID': '会员ID',
  'platform.point.Memberaccount': '会员账号',
  'platform.point.Event': '事件',
  'platform.point.Timeofevent': '发生事件时间',
  'platform.point.Amount': '金额',
  'platform.point.URLofevent': '发生事件网址',
  'platform.addPixelId': '增加像素ID',
  'platform.editPixelId': '修改像素ID',
  'platform.viewPixelId': '查看像素ID',
  'platform.trackMode': '埋点类型',
  'platform.trackModeCapi': '转化API（S2S埋点）',
  'platform.trackModeWeb': '浏览器（Web埋点）',
  'platform.inviteLink': '域名链接',

  // 推广渠道 / 推广域名
  'platform.promoChannel.channelId': '渠道ID',
  'platform.promoChannel.withdrawRegisterUrl': '提现引流注册地址',

  'platform.promoChannel.ticketRegisterUrl': '门票引流注册地址',
  'platform.promoChannel.edit': '编辑渠道',
  'platform.promoChannel.urlPlaceholder': '请输入地址',
  'platform.promoChannel.urlFormat': '请输入以 https:// 开头的有效地址，不能含空格',
  'platform.promoDomain.domain': '推广域名',
  'platform.promoDomain.add': '新增域名',
  'platform.promoDomain.edit': '编辑域名',
  'platform.promoDomain.editTip': '修改域名或所属渠道不会改变已注册用户的渠道',
  'platform.promoDomain.batchPlaceholder':
    '支持批量添加，最多{max}个，多个域名请换行，例如：123.com（换行输入）',
  'platform.promoDomain.tooMany': '一次最多新增 {max} 个域名',
  'platform.promoDomain.domainLabel': '域名',
  'platform.promoDomain.platform': '推广平台',
  'platform.promoDomain.platformOther': '其他',
  'platform.promoDomain.tipTitle': '提示：',
  'platform.promoDomain.tip1': '1、只能添加拥有自主控制权的域名。例如：域名注册商处购买的域名等。',
  'platform.promoDomain.tip2':
    '2、添加域名后，请将该域名以NS方式解析至CDN服务商提供的权威服务器域名。',
  'platform.promoDomain.tip3':
    '3、成功添加解析且主域名状态显示为【正常】后，域名托管成功可以使用。',
  'platform.promoDomain.invalid': '域名格式不正确：{domain}',
  'platform.promoDomain.duplicate': '存在重复的域名：{domain}',
  'platform.promoDomain.deleteConfirm': '确定删除该域名吗？已绑定像素的域名需先解除绑定',

  'platform.operLog': '操作日志',
  'platform.operContent': '操作内容',
  'platform.operIp': '操作IP',

  'report.buriedPointRecord.export': '埋点记录',
  'report.buriedPointRecord.parentAccountID': '上级账号ID',
  'report.buriedPointRecord.accountID': '账号ID',
  'report.buriedPointRecord.promotionLink': '推广链接',
  'report.buriedPointRecord.eventId': '事件ID',
  'report.buriedPointRecord.pushStatus': '转发状态',
  'report.buriedPointRecord.pushPending': '待推送',
  'report.buriedPointRecord.pushSuccess': '成功',
  'report.buriedPointRecord.pushFail': '失败',
  'report.buriedPointRecord.pushSkip': '不转发',
  // 短信设置
  'platform.smsConfig.smsPlatform': '短信平台',
  'platform.smsConfig.supportCountry': '支持国家/地区',
  'platform.smsConfig.contact': '联系方式',
  'platform.smsConfig.fee': '短信收费',
  'platform.smsConfig.feePlaceholder': '短信收费, 最多50个字符',
  'platform.smsConfig.currentBalance': '当前余额',
  'platform.smsConfig.alertEnabled': '提醒余额开关',
  'platform.smsConfig.alertThreshold': '当余额小于进行提醒',
  'platform.smsConfig.alertThresholdPrefix': '当余额小于',
  'platform.smsConfig.makeRemind': '进行提醒',
  'platform.smsConfig.channelStatus': '通道状态',
  'platform.smsConfig.statusUnchecked': '未检测',
  'platform.smsConfig.statusNormal': '正常',
  'platform.smsConfig.statusLow': '余额不足',
  'platform.smsConfig.statusFailed': '检测失败',
  'platform.smsConfig.dailyLimit': '每日封顶',
  'platform.smsConfig.noLimit': '不封顶',
  'platform.smsConfig.todayRemain': '今日剩余',
  'platform.smsConfig.todaySent': '今日已发数量',
  'platform.smsConfig.todaySuccess': '今日成功数量',
  'platform.smsConfig.todayFail': '今日失败数量',
  'platform.smsConfig.selectCountry': '选择国家',
  'platform.smsConfig.platform': '平台',
  'platform.smsConfig.enable': '启用',
  'platform.smsConfig.disable': '停用',
  'platform.smsConfig.alertLow': '短信余额不足，请及时充值',
  'platform.smsConfig.alertFailed': '短信余额检测失败，请检查通道配置',
};
